import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import { getApi } from "./api-client";

/* =======================
   DEFAULT MULTISELECT STYLES
======================= */
const getOptionBackgroundColor = (state) => {
  if (state.isSelected) return "#007bff";
  if (state.isFocused) return "#e0e0e0";
  return "#fff";
};

const defaultMultiSelectStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "0.7px solid #E5E5E5",
    padding: "2px",
    fontWeight: "500",
    fontSize: "13px",
    color: "#212129",
    cursor: "pointer",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: getOptionBackgroundColor(state),
    color: state.isSelected ? "#fff" : "#333",
    padding: 10,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#F6F7F8",
    borderRadius: "5px",
    padding: "2px 5px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#212129",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#212129",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 99999,
  }),
};

const CommonAsyncSelect = ({
  isMulti = true,
  value,
  onChange,
  placeholder = "Search...",
  styles = defaultMultiSelectStyles,
  isClearable = false,
  cacheOptions = true,
  defaultOptions = true,
  isDisabled = false,
  apiUrl,
  queryKey = "term",
  delay = 500,
}) => {
  const loadOptions = useCallback(
    (inputValue, callback) => {
      setTimeout(async () => {
        try {
          const res = await getApi(apiUrl, {
            [queryKey]: inputValue ?? "",
          });

          const options =
            res?.suggestionlist?.map((item) => ({
              value: String(item.value),
              label: String(item.label),
            })) || [];

          callback(options);
        } catch (error) {
          console.error("AsyncSelect API Error:", error);
          callback([]);
        }
      }, delay);
    },
    [apiUrl, queryKey, delay]
  );

  return (
    <AsyncSelect
      isMulti={isMulti}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      placeholder={placeholder}
      styles={styles}
      isClearable={isClearable}
      cacheOptions={cacheOptions}
      defaultOptions={defaultOptions}
      isDisabled={isDisabled}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
    />
  );
};

export default CommonAsyncSelect;
